import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogContentText from "@mui/material/DialogContentText";
import { TextField, Button, FormControl, makeStyles } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import TableViewService from "../../services/tableview.service.js";
import ConfigurationViewService from "../../services/configurationview.service";

export default function MenuPositionConfig() {
  const [menus, setMenus] = useState([]);
  const [selectedMenuId, setSelectedMenuId] = useState("");
  const [menuPosition, setMenuPosition] = useState("");
  const [subMenus, setSubMenus] = useState([]);
  const [payload, setPayload] = useState(null);
  const [saveConfiguration, setSaveConfiguration] = useState(false);

  const [message, setMessage] = useState();
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [openFaildialog, setOpenFaildialog] = useState(false);

  // Load TableWidgetPositionConfig
  useEffect(() => {
    if (!selectedMenuId) return;

    let dashboardName = "TableWidgetPositionConfig";
    let keyName = selectedMenuId;
    async function loadTableWidgetPositionConfig() {
      try {
        const response = await ConfigurationViewService.getPayload(
          dashboardName,
          keyName,
        );
        if (response.data) {
          const cleanedData = (({ _id, __v, ...rest }) => rest)(response.data);
          setPayload(cleanedData);
        } else {
          setPayload(null);
        }
      } catch (err) {
        console.error(err);
        setPayload(null);
      }
    }
    loadTableWidgetPositionConfig();
  }, [selectedMenuId]);

  // Load menu list
  useEffect(() => {
    async function loadMenus() {
      try {
        const response =
          await TableViewService.getAllRowsData("TableGroupList");
        if (response) {
          setMenus(response.data.map((item) => item.GroupName));
        }
      } catch (err) {
        console.error(err);
      }
    }
    loadMenus();
  }, []);

  // Load submenus on menu select
  useEffect(() => {
    if (!selectedMenuId) return;

    async function loadSubMenus() {
      try {
        const response = await TableViewService.getAllRowsData("TableList");
        if (response) {
          const widgets = response.data
            .filter((item) =>
              item.tablegroupnamelist?.some((group) =>
                selectedMenuId.includes(group),
              ),
            )
            .map((item) => ({
              name: item.WidgetName,
              position: "",
            }));

          setSubMenus(widgets);
        }
      } catch (err) {
        console.error(err);
      }
    }
    loadSubMenus();
  }, [selectedMenuId]);

  // Update submenu position
  const updateSubMenuPosition = (name, value) => {
    setSubMenus((prev) =>
      prev.map((sub) =>
        sub.name === name ? { ...sub, position: Number(value) } : sub,
      ),
    );
  };

  useEffect(() => {
    async function saveRowData() {
      try {
        let dashboardName = "TableWidgetPositionConfig";
        //const response =1
        const response = await ConfigurationViewService.savePayload(
          dashboardName,
          payload,
        );
        if (response?.data?.success) {
          setOpenSuccessDialog(true);
          setMessage(response.data.message || "Saved successfully");
          setSaveConfiguration(false);
        }
      } catch (error) {
        setOpenFaildialog(true);
        setMessage(
          "Error While Editing Record, Please verify all parameters entered in form",
        );
        setSaveConfiguration(false);
        console.log(error);
      }
    }
    if (saveConfiguration === true) {
      saveRowData();
    }
  }, [saveConfiguration]);

  // Save config
  const saveConfig = () => {
    const payload0 = {
      menuName: selectedMenuId,
      menuPosition: Number(menuPosition),
      subMenus: subMenus.map((s) => ({
        name: s.name,
        position: Number(s.position),
      })),
    };
    setPayload(payload0);
    //console.log(payload0);
    setSaveConfiguration(true);
  };

  const handleSuccessClose = () => {
    setOpenSuccessDialog(false);
  };

  const handleFaildClose = () => {
    setOpenFaildialog(false);
  };

  return (
    <div
      style={{
        display: "flex",
        gap: 20,
        alignItems: "flex-start",
        margin: "40px auto",
        maxWidth: 1000,
        fontFamily: "Arial, sans-serif",
      }}
    >
      {/* Success dialog after upgradtion of teh user info. */}
      <Dialog open={openSuccessDialog} onClose={handleSuccessClose}>
        <DialogTitle> success.. </DialogTitle>
        <DialogContent>
          <DialogContentText>{message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSuccessClose}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Save Changes Failed dialog /Wrong Password */}
      <Dialog open={openFaildialog} onClose={handleFaildClose}>
        <DialogTitle> Failed.. </DialogTitle>
        <DialogContent>
          <DialogContentText>{message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleFaildClose}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* LEFT: PAYLOAD PREVIEW */}
      <div
        style={{
          flex: 1,
          padding: 20,
          borderRadius: 8,
          background: "#fff",
          height: 450,
          maxHeight: 450,
          overflowY: "auto",
          border: "1px solid #e0e0e0",
        }}
      >
        <h4 style={{ marginTop: 0, marginBottom: 12 }}>
          Present Menu Position Configuration
        </h4>

        {!payload ? (
          // When payload is null / undefined
          <div style={{ color: "#999", fontStyle: "italic" }}>
            No configuration available
          </div>
        ) : (
          <>
            {/* Menu Name */}
            <div
              style={{
                fontWeight: 600,
                fontSize: 16,
                marginBottom: 10,
                color: "#1976d2",
              }}
            >
              {payload.menuPosition ?? "-"} . {payload.menuName ?? "N/A"}
            </div>

            {/* Sub Menus */}
            {Array.isArray(payload.subMenus) && payload.subMenus.length > 0 ? (
              <ul style={{ paddingLeft: 20, margin: 0 }}>
                {payload.subMenus
                  .slice()
                  .sort((a, b) => (a.position ?? 0) - (b.position ?? 0))
                  .map((sub, index) => (
                    <li
                      key={index}
                      style={{
                        marginBottom: 6,
                        fontSize: 14,
                        color: "#333",
                      }}
                    >
                      <span style={{ marginRight: 8, fontWeight: 500 }}>
                        {sub.position ?? "-"}.
                      </span>
                      {sub.name ?? "Unnamed"}
                    </li>
                  ))}
              </ul>
            ) : (
              // When subMenus is empty or missing
              <div style={{ color: "#999", fontStyle: "italic" }}>
                No sub menus configured
              </div>
            )}
          </>
        )}
      </div>

      {/* RIGHT: FORM */}
      <div
        style={{
          flex: 1,
          padding: 20,
          border: "1px solid #ddd",
          borderRadius: 8,
          background: "#fafafa",
          height: 450,
          maxHeight: 450,
        }}
      >
        <h4 style={{ textAlign: "center", marginBottom: 20 }}>
          Set Menu Position Configuration
        </h4>

        {/* Menu & Position Row */}
        <div style={{ display: "flex", gap: 20 }}>
          <div style={{ flex: 1 }}>
            <label style={{ fontWeight: 600 }}>Select Menu</label>
            <select
              value={selectedMenuId}
              //onChange={(e) => setSelectedMenuId(e.target.value)}
              onChange={(e) => {
                setSelectedMenuId(e.target.value);
                setMenuPosition(""); // reset menu position
              }}
              style={{
                width: "100%",
                padding: 8,
                marginTop: 4,
              }}
            >
              <option value="">-- Select --</option>
              {menus.map((menu) => (
                <option key={menu} value={menu}>
                  {menu}
                </option>
              ))}
            </select>
          </div>

          <div style={{ flex: 1 }}>
            <label style={{ fontWeight: 600 }}>Main Menu Position</label>
            <input
              type="number"
              min={1}
              value={menuPosition}
              onChange={(e) => setMenuPosition(e.target.value)}
              style={{
                width: "100%",
                padding: 8,
                marginTop: 4,
              }}
            />
          </div>
        </div>

        {/* Submenus */}
        {selectedMenuId && (
          <>
            <div
              style={{
                marginTop: 20,
                padding: 12,
                border: "1px solid #ddd",
                borderRadius: 6,
                background: "#fff",
                maxHeight: 200,
                overflowY: "auto",
              }}
            >
              <strong>Sub Menu Positions</strong>

              {subMenus.map((sub) => (
                <div
                  key={sub.name}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: 10,
                  }}
                >
                  <span>{sub.name}</span>
                  <input
                    type="number"
                    min={1}
                    value={sub.position}
                    onChange={(e) =>
                      updateSubMenuPosition(sub.name, e.target.value)
                    }
                    style={{ width: 80, padding: 6 }}
                  />
                </div>
              ))}
            </div>

            <button
              onClick={saveConfig}
              style={{
                marginTop: 20,
                padding: "10px 16px",
                width: "100%",
                background: "#1976d2",
                color: "#fff",
                border: "none",
                borderRadius: 4,
                cursor: "pointer",
              }}
            >
              Save Configuration
            </button>
          </>
        )}
      </div>
    </div>
  );
}
